import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.TwoFaHardEnforcementPage.HardEnforcementEnd', {
    title: 'Two-factor authentication enabled',
    description:
        'You’re all set up. From now on, you’ll need both your password and an additional authentication method to log in ApprovalMax.',
    button: 'Done',
});
